import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import React, { Component } from "react"

import { Empty } from "antd"
import { Link } from "react-router-dom"
import Loader from "../../components/common/Loader"
import Pagination from "react-js-pagination"
import Sidebar from "../../components/sidebar"
import Url from "../../services/BaseUrl"
import { _Api } from "../../services/Api"
import { notify } from "../../components/common/Toaster"

class CustomerManagement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      consumerList: "",
      search: "",
      totalCount: 0,
      sortType: "",
      sortField: "",
      pageNo: 1,
      count: 10,
      loading: false,
      visible: false,
      isLoader: false,
      status: 1,
      ItemListView: {},
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: "",
      profileImage: "",
      totalConsumerResult: 0,
      totalAllConsumer: 0,
    }
  }

  componentDidMount() {
    this.getCustomerDetails()
  }

  handlePageChange = (pageNo) =>
    this.setState({ loader: true, pageNo }, () => this.getCustomerDetails())

  handleSearch = (e) => {
    this.setState({ search: e.target.value })
    if (e.target.value.length > 2) {
      this.setState({ search: e.target.value }, () => this.getCustomerDetails())
    }
    if (e.target.value === "") {
      this.setState({ search: e.target.value }, () => this.getCustomerDetails())
    }
  }
  handleSort = (sortField) =>
    this.setState(
      {
        loader: true,
        sortField,
        sortType: this.state.sortType === 1 ? -1 : 1,
      },
      () => this.getCustomerDetails()
    )
  handleUserStatus = (e) =>
    this.setState(
      {
        loader: true,
        userStatus: this.state.userStatus === 1 ? 0 : 1,
      },
      () => this.getCustomerDetails()
    )

  getCustomerDetails = () => {
    let self = this
    let { search, count, pageNo, totalCount, sortField, sortType } = this.state
    let req = {
      search,
      sortType,
      sortField,
      pageNo,
      count,
    }

    this.setState({ isLoader: true, loader: true })
    _Api(
      Url.GET_CUSTOMER.method,
      Url.GET_CUSTOMER.url,
      "",
      `?search=${req.search}&count=${req.count}&pageNo=${
        req.pageNo - 1
      }&sortType=${req.sortType}&sortField=${req.sortField}`
    )
      .then((data) => {
        this.setState({
          isLoader: false,
          loader: false,
        })
        console.log("resppp", data)
        if (data.statusCode === 1) {
          self.setState({
            consumerList: data.responseData.userProfile.consumerList,
            totalAllConsumer: data.responseData.userProfile.totalAllConsumer,
            totalConsumerResult:
              data.responseData.userProfile.totalConsumerResult,
            totalInActive: data.responseData.userProfile.totalInActive,
            totalActive: data.responseData.userProfile.totalActive,
            // totalCount: data.responseData.userProfile,
            isLoader: false,
          })
        } else {
          self.setState({ visible: false, isLoader: false })
          notify("error", data.error.responseMessage)
        }
        console.log("getresp", this.state.consumerList)
      })
      .catch((err) => {
        notify("error", err.data.error.responseMessage)
        self.setState({
          loader: false,
          isloader: false,
          errors: err.data.error.responseMessage,
        })
        this.setState({ isloader: false })
      })
  }

  handleOnChangeStatus = (id, status) => {
    let req = {
      userId: id,
      status,
    }
    let self = this
    this.setState({ isLoader: true })

    _Api(
      Url.SUPER_ADMIN_CHANGE_STATUS.method,
      Url.SUPER_ADMIN_CHANGE_STATUS.url,
      req
    )
      .then((resp) => {
        this.setState({ isLoader: false, loader: false })

        if (resp.statusCode === 1) {
          notify("success", resp.responseData.message)

          this.setState({ visible: false })
          this.getCustomerDetails()
        } else {
          this.setState({ visible: false, isLoader: false })
          notify("error", resp.error.responseMessage)
        }
      })
      .catch((err) => {
        notify("error", err.data.error.responseMessage)
        self.setState({
          loader: false,
          isloader: false,
          errors: err.data.error.responseMessage,
        })
        this.setState({ isloader: false })
      })
  }

  showModal = (id) => {
    this.setState({
      visible: true,
      selectedId: id,
    })
  }
  handleCancel = () => {
    this.setState({ visible: false })
  }
  handleClose = () => {
    this.setState({ visible: false, viewCustomer: false })
  }
  handleAciveInactiveStatus = (e, id) => {
    let self = this
    console.log("stsus", e.target, id)
    let req = {
      userId: id,
      status: e.target.checked ? 0 : 1,
    }
    this.setState({ isLoader: true })
    _Api(
      Url.SUPER_ADMIN_CHANGE_STATUS.method,
      Url.SUPER_ADMIN_CHANGE_STATUS.url,
      req
    )
      .then((resp) => {
        if (resp.statusCode === 1) {
          notify("success", resp.responseData.message)
          this.setState({ visible: false, isLoader: false })
          this.getCustomerDetails()
        } else {
          this.setState({ visible: false, isLoader: false })
          notify("error", resp.error.responseMessage)
        }
      })
      .catch((err) => {
        notify("error", err.data.error.responseMessage)
        self.setState({
          loader: false,
          isloader: false,
          errors: err.data.error.responseMessage,
        })
      })
  }

  handleVerify = (e, id) => {
    let self = this

    console.log("stsus", e.target, id)
    let req = {
      userId: id,
      status: e.target.checked ? 3 : 4,
    }
    _Api(
      Url.SUPER_ADMIN_CHANGE_STATUS.method,
      Url.SUPER_ADMIN_CHANGE_STATUS.url,
      req
    )
      .then((resp) => {
        if (resp.statusCode === 1) {
          console.log("delete", resp.responseData.message)
          notify("success", resp.responseData.message)
          this.setState({ visible: false })
          this.getCustomerDetails()
        } else {
          this.setState({ visible: false, isLoader: true })
          notify("error", resp.error.responseMessage)
        }
      })
      .catch((err) => {
        notify("error", err.data.error.responseMessage)
        self.setState({
          loader: false,
          isloader: false,
          errors: err.data.error.responseMessage,
        })
      })
  }
  openViewPopup = (e, item) => {
    this.setState({
      viewCustomer: true,
      firstName: item.firstName,
      lastName: item.lastName,
      email: item.email,
      phone: item.phone,
      address: item.address,
      profileImage: item.profileImage,
    })
  }

  render() {
    let {
      totalConsumerResult,
      totalAllConsumer,
      firstName,
      lastName,
      email,
      phone,
      address,
      profileImage,
      ItemListView,
      consumerList,
      viewCustomer,
      pageNo,
      count,
      search,
      totalCount,
      sortField,
      sortType,
      visible,
      loading,
      status,
      isLoader,
    } = this.state
    return (
      <>
        <Sidebar />
        <div className="body_container">
          <div className="body_inner_wrapper">
            {this.state.isLoader ? (
              <Loader />
            ) : (
              <>
                <header className="header_content">
                  {/*{isLoader && <Loader/>}*/}
                  <p>Customer Management</p>

                  <div className="header_search ">
                    <div className="form-group has-search">
                      <span className="fa fa-search form-control-feedback"></span>
                      <Form.Control
                        type="text"
                        placeholder="Search..."
                        maxLength={30}
                        name="search"
                        value={search}
                        onChange={this.handleSearch}
                      />
                    </div>
                  </div>

                  <div className="d-flex text-nowrap header_btn">
                    <Link to="/addcustomer" className="text-light">
                      <Button variant="warning">
                        <i class="fas fa-plus-circle"></i>
                        Add Customer
                      </Button>
                    </Link>
                  </div>
                </header>
                <div className="main_content">
                  <div class="table-responsive">
                    <table class="table cm_bottom_space">
                      <thead>
                        <tr class="broder_top_0">
                          <th scope="col">S.No.</th>
                          <th
                            scope="col"
                            className="ws-nowrap"
                            onClick={() => this.handleSort("firstName")}
                          >
                            {" "}
                            Customer Name
                            <i class="fas fa-sort text_dark ml-2 d-inline-block"></i>
                          </th>

                          {/*<th scope="col" className="ws-nowrap">Total Orders</th>*/}
                          <th scope="col">Phone</th>
                          <th scope="col">Email</th>
                          <th scope="col">Address</th>
                          {/*<th scope="col">Verify</th>*/}
                          <th scope="col">Inactive/Active</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {consumerList &&
                          consumerList.map((item, i) => (
                            <tr>
                              <td>{count * (pageNo - 1) + (i + 1)}</td>
                              <td>
                                {item.firstName} {item.lastName}
                              </td>
                              {/*<td>*/}
                              {/*    {item.totalOrder ? item.totalOrder : '0'}*/}
                              {/*</td>*/}
                              <td>{item.phone ? item.phone : "--"}</td>
                              <td>{item.email ? item.email : item.email}</td>
                              <td>
                                {" "}
                                {item.address.length > 0
                                  ? item.address[0].addressLine1
                                  : "--"}{" "}
                                &nbsp;
                                {item.address.length > 0
                                  ? item.address[0].addressLine2
                                  : ""}{" "}
                                &nbsp;
                                {item.address.length > 0
                                  ? item.address[0].city
                                  : ""}{" "}
                                &nbsp;
                                {item.address.length > 0
                                  ? item.address[0].state
                                  : ""}{" "}
                                &nbsp;
                                {item.address.length > 0
                                  ? item.address[0].postalCode
                                  : ""}{" "}
                              </td>
                              {/*<td>*/}
                              {/*    <div class="switch_wrapper">*/}
                              {/*        <input type="checkbox"*/}
                              {/*               onChange={(e) => this.handleVerify(e, item._id)}*/}
                              {/*        />*/}
                              {/*        <span class="checkbox_swich"></span>*/}
                              {/*    </div>*/}
                              {/*</td>*/}
                              <td>
                                <div class="switch_wrapper">
                                  <input
                                    type="checkbox"
                                    checked={item.status === 1 ? false : true}
                                    onChange={(e) =>
                                      this.handleAciveInactiveStatus(
                                        e,
                                        item._id
                                      )
                                    }
                                  />
                                  <span class="checkbox_swich"></span>
                                </div>
                              </td>
                              <td className="ws-nowrap">
                                <div className="action_wrapper">
                                  <span>
                                    <Link
                                    // to={`/farmermanagement/farmerdetails/${item._id}`}
                                    >
                                      <i
                                        onClick={(e) =>
                                          this.openViewPopup(e, item)
                                        }
                                        class="fas fa-eye"
                                      ></i>
                                    </Link>
                                  </span>

                                  <span></span>
                                  <span
                                    onClick={() => this.showModal(item._id)}
                                  >
                                    <i className="fas fa-trash-alt text-danger"></i>
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>

                    {console.log(isLoader, "ssssssssssssssssssssssasasa")}
                    {consumerList && consumerList.length ? (
                      ""
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )}
                  </div>
                  {
                    //proper

                    totalConsumerResult && totalConsumerResult ? (
                      <div className="d-flex justify-content-end cm-pagination">
                        {totalConsumerResult ? (
                          <Pagination
                            activePage={pageNo}
                            itemsCountPerPage={count}
                            totalItemsCount={totalAllConsumer}
                            pageRangeDisplayed={3}
                            onChange={this.handlePageChange}
                            itemClassPrev={"prevClass"}
                            itemClassNext={"nextClass"}
                            // prevPageText={<i className="fa fa-caret-left"/>}
                            // nextPageText={<i className="fa fa-caret-right"/>}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )
                  }
                </div>{" "}
              </>
            )}
          </div>
        </div>
        <Modal
          show={visible}
          onHide={this.handleCancel}
          className="cm_order_view dlt_item"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <img src={require("../../assets/img/Delete-Email.png")} />
            <br />
            <br />
            <p>Are you sure you want to delete this customer?</p>
          </Modal.Body>
          <Modal.Footer>
            <div className="footer_btn_wrapper btn_nospace">
              <Button
                variant="warning"
                loading={loading}
                onClick={() =>
                  this.handleOnChangeStatus(this.state.selectedId, 2)
                }
              >
                Yes
              </Button>
              <Button variant="dark" onClick={this.handleCancel}>
                No
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={viewCustomer}
          onHide={this.handleClose}
          className="cm_order_view edit_item inventry"
        >
          <Modal.Header closeButton>
            <Modal.Title> Customer Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {profileImage ? (
              <Row>
                <Col md="4">
                  <p>Profile Image</p>
                </Col>
                <Col md="8">
                  <div
                    className="file_uploader"
                    style={{ backgroundImage: `url(${profileImage})` }}
                  >
                    <>
                      <div className="overlay"></div>
                    </>
                  </div>
                </Col>
              </Row>
            ) : (
              ""
            )}

            {firstName ? (
              <Row>
                <Col md="4">
                  <p>Name</p>
                </Col>
                <Col md="8">
                  <Form.Control
                    type="text"
                    onChange={this.handleChanged}
                    disabled
                    name="firstName"
                    value={firstName}
                    placeholder=" "
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}

            {email ? (
              <Row>
                <Col md="4">
                  <p> Email</p>
                </Col>
                <Col md="8">
                  <Form.Control
                    type="text"
                    onChange={this.handleChanged}
                    disabled
                    name="email"
                    value={email}
                    placeholder=" "
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}
            {phone ? (
              <Row>
                <Col md="4">
                  <p> Phone Number</p>
                </Col>
                <Col md="8">
                  <Form.Control
                    type="text"
                    onChange={this.handleChanged}
                    disabled
                    name="phone"
                    value={phone}
                    placeholder="Recipe name"
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}

            {address ? (
              <Row>
                <Col md="4">
                  <p> Address</p>
                </Col>
                <Col md="8">
                  <p className="form-control">
                    {address.length > 0 ? address[0].addressLine1 : "--"} &nbsp;
                    {address.length > 0 ? address[0].addressLine2 : ""} &nbsp;
                    {address.length > 0 ? address[0].city : ""} &nbsp;
                    {address.length > 0 ? address[0].state : ""} &nbsp;
                    {address.length > 0 ? address[0].postalCode : ""}
                  </p>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Modal.Body>

          <Modal.Footer>
            <div className="footer_btn_wrapper">
              <Button variant="dark" onClick={this.handleClose}>
                Cancel
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}

export default CustomerManagement
